module.exports = __webpack_public_path__ + "static/aligners01-63a4086a788debd77ff135cb10490b17.jpg";